import { seriesColorMap, seriesOptionsMap } from "../../options/historical-charts/series-options.values"
import { ChartType } from "./historical-chart.enum"
import { isCustomSeries, Series, seriesDefinitionsMap, SeriesTypeEnum } from "./series"
import { TimeRange } from "./time-range.enum"
import { HistoricalChartOptions, getTimeRanges } from "../../options/historical-charts/historical-chart.options"

export class Chart {
  constructor(
    public type: ChartType,
    public seriesType: SeriesTypeEnum,
    public timeRange: TimeRange,
    public description: string = '',
    public source: string = '',
    public series: Array<Series> = [],
  ) { }

  get chartOptions() {
    const options = HistoricalChartOptions.get(this.type)!
    // console.log(options)
    return options
  }
  get timeRanges() { return getTimeRanges(this.type) }
  get seriesDefinitions() { return seriesDefinitionsMap.get(this.seriesType)! }
  get seriesOptions() { return seriesOptionsMap.get(this.seriesType)! }
  get seriesColors() {
    return seriesColorMap.get(this.seriesType)?.list ?? [];
  }

  get isSingleSeries() { return this.series.length === 1 }
  get isCustomSeries() { return isCustomSeries(this.seriesDefinitions) }

  public sortSeriesByMax() {
    this.series.sort((a, b) => b.max - a.max)
  }
}

